export type EditorFontId =
  | "literata"
  | "young-serif"
  | "source-serif"
  | "spectral"
  | "garamond"
  | "atkinson"
  | "libre-baskerville"
  | "libre-caslon"
  | "cardo"
  | "benne"
  | "alegreya"
  | "fanwood"
  | "vollkorn";

export type EditorFontOption = {
  id: EditorFontId;
  label: string;
  stack: string;
};

export const EDITOR_FONTS: EditorFontOption[] = [
  {
    id: "literata",
    label: "Literata",
    stack: 'Literata, "Source Serif 4", Georgia, serif',
  },
  {
    id: "young-serif",
    label: "Young Serif",
    stack: '"Young Serif", Literata, Georgia, serif',
  },
  {
    id: "source-serif",
    label: "Source Serif",
    stack: '"Source Serif 4", "Iowan Old Style", Palatino, Georgia, serif',
  },
  {
    id: "spectral",
    label: "Spectral",
    stack: "Spectral, Literata, Georgia, serif",
  },
  {
    id: "garamond",
    label: "EB Garamond",
    stack: '"EB Garamond", "Palatino Linotype", Palatino, serif',
  },
  {
    id: "atkinson",
    label: "Atkinson",
    stack: '"Atkinson Hyperlegible", system-ui, sans-serif',
  },
  {
    id: "libre-baskerville",
    label: "Libre Baskerville",
    stack: '"Libre Baskerville", Georgia, "Times New Roman", serif',
  },
  {
    id: "libre-caslon",
    label: "Libre Caslon",
    stack: '"Libre Caslon Text", "Libre Baskerville", Georgia, serif',
  },
  {
    id: "cardo",
    label: "Cardo",
    stack: 'Cardo, "EB Garamond", Palatino, serif',
  },
  {
    id: "benne",
    label: "Benne",
    stack: "Benne, Literata, Georgia, serif",
  },
  {
    id: "alegreya",
    label: "Alegreya",
    stack: "Alegreya, Literata, Georgia, serif",
  },
  {
    id: "fanwood",
    label: "Fanwood",
    stack: '"Fanwood Text", "Libre Baskerville", Georgia, serif',
  },
  {
    id: "vollkorn",
    label: "Vollkorn",
    stack: 'Vollkorn, "Source Serif 4", Georgia, serif',
  },
];

export const DEFAULT_BODY_FONT: EditorFontId = "literata";
export const DEFAULT_HEADING_FONT: EditorFontId = "young-serif";

export function isEditorFontId(value: unknown): value is EditorFontId {
  return EDITOR_FONTS.some((font) => font.id === value);
}

export function fontStackFor(id: EditorFontId): string {
  return (
    EDITOR_FONTS.find((font) => font.id === id)?.stack ?? EDITOR_FONTS[0]!.stack
  );
}
